export default "__VITE_ASSET__DQtngQML__"